import type { Dict } from "./en";

export const ru: Dict = {
  brand: { tagline: "Зал для просмотра аниме." },
  nav: { collections: "Подборки", discover: "Главная", browse: "Каталог", library: "Мой список", admin: "Админка" },
  userMenu: {
    profile: "Профиль",
    list: "Мой список",
    friends: "Друзья",
    trophies: "Трофеи",
    collections: "Подборки",
    forYou: "Для вас",
    customise: "Настроить профиль",
    look: "Оформление",
    admin: "Админка",
    support: "Поддержка",
    supportHint: "PRO-рамки и своя приписка",
    toNext: "до {n} ур. — {xp} опыта",
  },
  roll: {
    title: "Случайное аниме",
    hint: "только с плеером",
    error: "Не получилось — попробуйте ещё раз",
    watch: "Смотреть",
    again: "Ещё раз",
  },
  cookies: {
    text: "Используем cookie для входа, настроек и статистики.",
    accept: "Принять",
    decline: "Отказаться",
  },
  common: {
    search: "Поиск аниме",
    searchShort: "Поиск",
    signIn: "Войти",
    signOut: "Выйти",
    createAccount: "Регистрация",
    account: "Аккаунт",
    tryAgain: "Повторить",
    browseCatalogue: "Открыть каталог",
    seeAll: "Смотреть все",
    menu: "Меню",
    clear: "Очистить",
    loading: "Загрузка",
    pageOf: "Стр. {page} из {total}",
    results: "Найдено: {count}",
    showMore: "Показать полностью",
    showLess: "Свернуть",
    ratings: "оценок: {count}",
    episode: "эпизод",
    episodes: "эп.",
    feature: "Полный метр",
    all: "Все",
    optional: "необязательно",
    previous: "Назад",
    next: "Вперёд",
    moreInfo: "Подробнее",
    copy: "Копировать",
    save: "Сохранить",
    cancel: "Отмена",
    edit: "Изменить",
    delete: "Удалить",
    reply: "Ответить",
    report: "Пожаловаться",
    week: "Неделя",
    month: "Месяц",
    allTime: "Всё время",
    day: "День",
    none: "Нет",
    preview: "Предпросмотр:",
  },
  card: {
    watch: "Смотреть",
    addToList: "В список",
    inList: "Уже в списке",
    soon: "Скоро выйдет",
    countdownDays: "через {days} дн.",
    countdownHours: "через {hours} ч.",
    countdownSoon: "со дня на день",
    releaseOn: "выходит {date}",
  },
  theme: { label: "Тема", toLight: "Светлая тема", toDark: "Тёмная тема" },
  locale: { label: "Язык", switchTo: "Переключить на {language}" },
  pwa: {
    install: "Установить приложение",
    installHint: "Установите Anivora на телефон — свой значок на экране, список открывается даже без сети.",
    iosDialogTitle: "Установка на iPhone/iPad",
    iosDialogBody: "Safari не даёт установить сайт по кнопке — только вручную, через «Поделиться».",
    iosStep1: "Нажмите значок «Поделиться» в панели браузера",
    iosStep2: "Выберите «На экран «Домой»»",
    gotIt: "Понятно",
  },
  footer: {
    welcome: "Приятного просмотра! Здесь можно смотреть аниме бесплатно, отмечать серии и собирать свой список.",
    support: "Поддержка",
    tagline: "Тёмный зал, где всё внимание — аниме.",
    description:
      "Один каталог, список просмотра и прогресс по эпизодам. Без лишнего шума.",
    nav: "Навигация",
    project: "Проект",
    social: "Мы в соцсетях",
    legal: "Правовое",
    about: "О проекте",
    pro: "PRO и поддержка",
    profile: "Ваш профиль",
    randomAnime: "Случайное аниме",
    disclaimer:
      "Все права на произведения принадлежат их правообладателям. По вопросам использования материалов свяжитесь с администрацией через раздел «Правообладателям».",
    rights: "© {year} Anivora",
    madeWith: "Сделано фанатами аниме — для фанатов аниме.",
    toTop: "Наверх",
  },
  contactSupport: {
    eyebrow: "Помощь Anivora",
    title: "Связаться с поддержкой",
    lead: "Напиши нам, если возникла проблема со входом, просмотром или работой сайта. Постараемся помочь.",
    telegramTitle: "Поддержка в Telegram",
    telegramBody: "Бот задаст один вопрос, сохранит обращение и передаст его команде поддержки.",
    telegramAction: "Написать боту",
    emailTitle: "Поддержка по Email",
    emailBody: "Можно написать нам по электронной почте. Адрес добавим сюда, когда настроим почту поддержки.",
    emailConfiguredBody: "Напиши нам по электронной почте — команда поддержки ответит на твоё письмо.",
    emailAction: "Написать на Email",
    emailPending: "Email скоро появится",
    privacy: "Не отправляй пароль, код входа или данные банковской карты.",
  },
  discover: {
    title: "Обзор",
    error: "Не удалось загрузить обзор",
    errorBody: "Не получилось связаться с каталогом. Обычно это ненадолго.",
    thisSeason: "В этом сезоне",
    topAiring: "Сейчас в эфире — топ по оценке",
    mostPopular: "Самое популярное",
    allTimeTop: "Лучшее за всё время",
    viewDetails: "Подробнее",
  },
  collections: {
    themed: "Тематические подборки",
    fromViewers: "Подборки зрителей",
    theme: "Тема",
    random: "Случайная подборка",
    votes: "{n} голосов",
    yourRating: "Ваша оценка — можно изменить",
    rateHint: "Наведите на звезду",
    rate: { bad: "Плохо", meh: "Так себе", ok: "Нормально", good: "Хорошо", masterpiece: "Шедевр" },
    byAuthor: "Автор подборки",
    you: "Вы",
    reply: "Ответить",
    replyingTo: "Ответ для {name}",
    replyPlaceholder: "Ваш ответ…",
    moreReplies: "Показать ещё ответы: {n}",
    eyebrow: "Подборки",
    title: "Подборки зрителей",
    lead: "Списки аниме с историей: авторы объясняют, почему советуют каждый тайтл. Читайте, оценивайте и собирайте свои.",
    create: "Создать подборку",
    myStats: "Моя статистика",
    signInToCreate: "Войдите, чтобы создать подборку",
    limitReached: "Лимит подборок — оформить PRO",
    limitFree: "Подборок: {n} из {max}",
    limitPro: "Подборок: {n} · без ограничений с PRO",
    search: "Найти подборку…",
    allTags: "Все",
    empty: "Подборок пока нет — станьте первым автором.",
    draft: "Черновик",
    animeCount: "{n} аниме",
    openAnime: "Открыть тайтл",
    contents: "Содержание",
    totals: "{n} аниме · {eps} серий · ≈{hours} ч",
    avgScore: "средний балл {score}",
    authorScore: "Оценка автора",
    mustWatch: "Обязательно к просмотру",
    showSpoiler: "Показать спойлер",
    commentsClosed: "Автор отключил комментарии к этой подборке.",
    stats: "Статистика",
    deleteConfirm: "Удалить подборку? Её оценки и комментарии тоже исчезнут.",
    rateTitle: "Как вам подборка?",
    rateOwn: "Это ваша подборка — оценки ставят читатели",
    rated: "Оценка сохранена",
    ratingLine: "Средняя оценка {avg} · {n} голосов",
    noRatings: "Пока никто не оценил",
    signInToRate: "Войдите, чтобы оценить",
    comments: "Обсуждение",
    commentPlaceholder: "Что думаете о подборке?",
    send: "Отправить",
    signInToComment: "Войдите, чтобы оставить комментарий",
    noComments: "Комментариев пока нет.",
    shelf: "Подборки",
    shelfEmpty: "Соберите первую подборку — расскажите, что и почему стоит посмотреть.",
    statsTitle: "Статистика подборок",
    statsLead: "Сколько вас читают, как оценивают и что обсуждают — по каждой подборке и в целом.",
    statsEmpty: "У вас пока нет подборок.",
    statViews: "Просмотры",
    statUnique: "Уникальных за 30 дней",
    statRating: "Средняя оценка",
    statRatings: "Оценок",
    statComments: "Комментарии",
    statDaily: "Просмотры за 30 дней",
    statTable: "По подборкам",
    statOne: "«{title}» за 30 дней",
    statDistribution: "Оценки",
    statNoData: "За этот период данных нет",
    colTitle: "Подборка",
    col7d: "За 7 дней",
    sort: { popular: "Популярные", new: "Новые", top: "Лучшие" },
    tags: {
      newcomers: "Для новичков",
      veterans: "Для опытных",
      cozy: "Уютное",
      dark: "Мрачное",
      funny: "Смешное",
      tearjerker: "До слёз",
      epic: "Эпичное",
      mindbending: "Взрыв мозга",
      romance: "Романтика",
      short: "Короткое",
      movies: "Фильмы",
      binge: "На запой",
      "hidden-gems": "Недооценённое",
      classics: "Классика",
    },
    editor: {
      titlePh: "Название подборки",
      summaryPh: "Пара строк о том, что объединяет эти тайтлы",
      textPh: "Текст: вступление, мысли, переход к следующему тайтлу…",
      notePh: "Почему этот тайтл здесь? Что в нём цепляет?",
      addText: "Текст",
      addAnime: "Аниме",
      addHeading: "Раздел",
      addQuote: "Цитата",
      addCallout: "Плашка",
      addDivider: "Разделитель",
      headingPh: "Название раздела",
      quotePh: "Цитата…",
      quoteByPh: "Кто сказал (необязательно)",
      calloutPh: "Совет, предупреждение или пояснение…",
      callout: { tip: "Совет", warning: "Внимание", info: "Инфо" },
      myScore: "Моя оценка",
      noScore: "без оценки",
      mustWatch: "Обязательно",
      spoiler: "Спойлер",
      watchTipPh: "Как смотреть: «с 2 сезона», «сначала фильм»…",
      look: "Оформление",
      layout: { list: "Список", ranked: "Топ", grid: "Сетка" },
      layoutHint: { list: "Карточки одна под другой", ranked: "Крупные номера мест", grid: "Постеры плиткой" },
      accent: "Цвет",
      accentNone: "Как на сайте",
      comments: "Комментарии",
      commentsOn: "Можно комментировать",
      commentsOff: "Комментарии выключены",
      searchAnime: "Название аниме…",
      duplicate: "Это аниме уже есть в подборке",
      coverHint: "Добавьте аниме — из их обложек соберётся заставка",
      criteria: "Критерии",
      public: "Опубликована",
      publicHint: "Видна всем в ленте подборок",
      draft: "Черновик",
      draftHint: "Видна только вам",
      counts: "Аниме в подборке: {n}",
      limit: "На обычном аккаунте можно вести до {max} подборок.",
      publish: "Опубликовать",
      update: "Сохранить изменения",
      saved: "Подборка сохранена",
      needs: "Нужны название (от 3 символов) и хотя бы одно аниме.",
    },
  },
  browse: {
    pageTitle: "Каталог аниме",
    resetCount: "Сбросить ({count})",
    genresPicked: "Выбрано жанров: {count}",
    genreRemove: "Убрать жанр",
    genreModeIn: "Нужны",
    genreModeOut: "Исключить",
    genresDone: "Готово",
    showResults: "Показать {count}",
    showResultsBare: "Показать",
    moreFilters: "Ещё фильтры",
    listLabel: "Показать",
    everything: "Весь каталог",
    anyShort: "Любой",
    withPlayerShort: "С плеером",
    anyLength: "Любая",
    allGenres: "Все жанры · {count}",
    savedNone: "Подборок пока нет",
    hideListedShort: "Скрыть мои",
    studioShort: "Любая",
    title: "Каталог",
    subtitle:
      "Фильтры по формату, статусу, оценке, году и жанрам. Поиск ищет по названиям в каталоге.",
    filters: "Фильтры",
    filtersHint: "Сузьте выборку.",
    search: "Поиск",
    searchPlaceholder: "Название, жанр, персонаж или настроение…",
    sortBy: "Сортировка",
    format: "Формат",
    anyFormat: "Любой формат",
    status: "Статус выхода",
    anyStatus: "Любой статус",
    minScore: "Минимальная оценка",
    minScoreValue: "{value}+",
    anyScore: "Любая",
    year: "Год",
    anyYear: "Любой год",
    genres: "Жанры",
    anyGenre: "Любой жанр",
    genresSelected: "выбрано: {count}",
    noGenre: "Жанр не найден.",
    onlyWithPlayer: "Только с плеером",
    onlyOwnPlayer: "Кастомный плеер",
    quick: {
      customPlayer: "Кастомный плеер",
      airingNow: "Сейчас выходит",
      topRated: "Топ рейтинга",
      newest: "Новинки",
    },
    searching: "Ищем…",
    scoreRange: "Оценка",
    maxScoreValue: "до {value}",
    yearRange: "Годы выхода",
    episodes: "Длина",
    episodesChip: "{from}–{to} серий",
    episodePreset: {
      one: "Фильм / 1",
      short: "до 13",
      cour2: "14–26",
      long: "27–100",
      huge: "100+",
    },
    genresHint: "Нажмите раз — жанр нужен, ещё раз — исключить, третий — сбросить.",
    genreSearch: "Найти жанр…",
    studio: "Студия",
    studioPlaceholder: "Начните вводить: MAPPA, Madhouse…",
    more: "Ещё",
    hideListed: "Скрыть то, что уже в моём списке",
    saved: "Мои подборки",
    saveSet: "Сохранить текущие фильтры",
    setName: "Название подборки",
    savedEmpty: "Настройте фильтры и сохраните их в одно нажатие.",
    presets: {
      airing: "Онгоинги",
      top: "Топ за всё время",
      short: "Короткие",
      movies: "Фильмы",
      own: "Наш плеер",
      fresh: "Новинки",
    },
    random: "Случайное из выборки",
    headerGenres: "{count} жанров · фильтры, диапазоны и подборки",
    randomNone: "По этим фильтрам нечего выбрать",
    loadMore: "Показать ещё",
    shown: "Показано {shown} из {total}",
    toTop: "К началу",
    clearAll: "Сбросить фильтры",
    noResultsTitle: "Ничего не найдено",
    noResultsWithQuery:
      'По запросу «{query}» ничего нет. Попробуйте шире или снимите часть фильтров.',
    noResults: "Под эти фильтры ничего не подходит. Ослабьте их и попробуйте снова.",
  },
  sort: {
    fresh: "Популярные новинки",
    popularity: "По популярности",
    score: "По оценке",
    rank: "По рейтингу",
    start_date: "Сначала новые",
    title: "По названию А–Я",
  },
  trailer: { open: "Трейлер", title: "{title} — трейлер" },
  detail: {
    quickFacts: {
      sheet: "Калькулятор времени",
      marathon: "Марафон-калькулятор",
      perDay: "{n} эп. в день",
      finish: "Досмотрите за {days} дн. — к {date}",
      aDay: "{minutes} мин в день",
      totalTime: "≈ {time} на весь тайтл",
      byDays: "≈ {days} дн. по {perDay} серии в день",
      byPerDay: "Серий в день",
      byDate: "К дате",
      pickDate: "Когда хотите закончить?",
      needPerDay: "{n} эп. в день",
      prevMonth: "Предыдущий месяц",
      nextMonth: "Следующий месяц",
      toggleHint: "Нажмите, чтобы посчитать иначе",
      perEpisode: "{episodes} эп. × {minutes} мин",
      rank: "#{rank} в рейтинге",
      members: "{count} в списках",
      favorites: "{count} в избранном",
      h: "ч",
      min: "мин",
      cardTitle: "Сколько смотреть",
      paceLabel: "Серий в день",
      fewer: "Меньше серий в день",
      more: "Больше серий в день",
      details: "Подробнее",
      film: "Один фильм",
    },
    notValid: "Неверная ссылка",
    notValidBody: "Похоже, ссылка битая.",
    notFound: "Аниме не найдено",
    notFoundBody: "Возможно, такого тайтла нет в каталоге или ссылка неверна.",
    loadError: "Не удалось загрузить",
    loadErrorBody: "Не получилось получить этот тайтл. Обычно временно.",
    sections: {
      watch: "Смотреть",
      synopsis: "Описание",
      trailer: "Трейлер",
      episodes: "Эпизоды",
      info: "Информация",
      characters: "Персонажи",
      recommendations: "Похожее",
      mainCharacters: "Главные герои",
      details: "Детали",
      seasons: "Сезоны",
    },
    seasons: {
      openHint: "Нажмите, чтобы открыть",
    },
    machineTranslated: "Описание переведено автоматически",
    scoreHint: "Оценка MyAnimeList · голосов: {votes}",
    scoreHintBare: "Оценка MyAnimeList",
    ranked: "В рейтинге #{rank}",
    airedOf: "эпизодов: {episodes}",
    episodesHelpBody:
      "Отмечает серию как текущую и сохраняет прогресс — сам плеер переключает серии в своём собственном меню, здесь вы просто говорите сайту, на чём остановились.",
    nextEpisodeNumber: "Серия {episode}",
    nextEpisodeInDays: "через {days} дн.",
    nextEpisodeInHours: "через {hours} ч.",
    themes: "Темы",
    audience: "Аудитория",
    soundtrack: {
      title: "Саундтрек",
      opening: "Опенинг",
      ending: "Эндинг",
      play: "Включить",
      pause: "Пауза",
      seek: "Перемотка",
      source: "Слушать в AnimeThemes",
    },
    tags: "Теги сообщества",
    watchOfficially: "Смотреть официально",
    oneLiner: "{type}, {year} · {genres}",
    related: "Вам может понравиться",
    relatedEmpty: "Пока нечего посоветовать.",
    overview: "Обзор",
    episodeSearch: "Номер серии…",
    episodesPrev: "Предыдущие серии",
    episodesNext: "Следующие серии",
    episodeMark: "Отметить как просмотренную",
    episodeInfo: "О серии",
    episodeNone: "По этому номеру ничего нет.",
    episodeNumber: "Серия {n}",
    japaneseTitle: "Японское название",
    malId: "MAL ID",
    backToPlayer: "Вернуться к плееру",
    background: "История",
    audienceTitle: "Как смотрят этот тайтл",
    audienceTotal: "всего в списках: {count}",
    audienceStats: {
      watching: "Смотрят",
      completed: "Досмотрели",
      onHold: "Отложили",
      dropped: "Бросили",
      planToWatch: "Планируют",
    },
    mainRole: "Главный герой",
    showAllCharacters: "Показать всех ({count})",
    collapseCharacters: "Свернуть",
    searchCharacters: "Поиск персонажа…",
    noCharactersMatch: "Никого не нашлось по этому запросу.",
    characterModal: {
      tabAbout: "О персонаже",
      tabVoices: "Озвучка",
      tabAnime: "Аниме",
      tabManga: "Манга",
      voicedBy: "Озвучивает",
      japaneseName: "Японское имя",
      noDescription: "Описание пока не найдено.",
      loadError: "Не удалось загрузить описание персонажа.",
      facts: "Интересные факты",
      clickForMore: "Нажмите, чтобы узнать больше",
      aliases: "Также известен как",
      appearsInAnime: "Аниме с персонажем",
      appearsInManga: "Манга с персонажем",
      spoilers: "Спойлеры",
      revealSpoilers: "показать",
      animeAppearancesTitle: "Аниме с участием {name}",
      mangaAppearancesTitle: "Манга с участием {name}",
      voiceActorsTitle: "Актёры озвучки — {name}",
      openInNewTab: "Открыть",
    },
    adultGate: {
      title: "Контент 18+",
      body: "Тайтл для взрослых. Укажите дату рождения — один раз, и такие тайтлы откроются.",
      signInBody: "Тайтл для взрослых. Войдите или создайте аккаунт — после этого достаточно один раз указать дату рождения.",
      birthLabel: "Дата рождения",
      confirm: "Подтвердить и открыть",
      under18: "Этот тайтл доступен с 18 лет.",
      note: "Дату видите только вы, изменить её потом нельзя. Хентай на сайте не показывается ни при каких настройках.",
      leave: "Назад на главную",
    },
    facts: {
      format: "Формат",
      status: "Статус",
      episodes: "Эпизоды",
      aired: "Начало показа",
      ended: "Конец показа",
      season: "Сезон",
      source: "Первоисточник",
      duration: "Длительность",
      rating: "Возрастной рейтинг",
      studios: "Студии",
      popularity: "Популярность",
      members: "В списках",
      favorites: "В избранном",
    },
  },
  watch: {
    pipPlaceholder: "Плеер в отдельном окне — нажмите, чтобы вернуть",
    miniOn: "Смотреть в отдельном окне",
    miniOff: "Развернуть обратно",
    miniPlaceholder: "Плеер в окне — нажмите, чтобы вернуть",
    resumed: "Продолжаем с {time}",
    skippedOpening: "Опенинг пропущен",
    nextIn: "Серия {n} через {s}…",
    nextNow: "Сейчас",
    reportProblem: "Сообщить о проблеме с серией {episode}",
    reportTitle: "{title} · серия {episode} · {provider}",
    reportQuestion: "Что случилось?",
    reportNoVideo: "Видео не запускается",
    reportWrongEpisode: "Открывается другая серия",
    reportAudio: "Проблема со звуком или субтитрами",
    reportOther: "Другая проблема",
    reportNote: "Комментарий (необязательно)",
    reportSending: "Отправляем…",
    reportSend: "Отправить",
    reportCancel: "Отмена",
    reportUpdated: "Жалоба обновлена. Спасибо!",
    reportSent: "Сообщение о проблеме отправлено. Спасибо!",
    reportFailed: "Не удалось отправить сообщение. Попробуй позже.",
    pref: {
      skipOpening: "Пропуск OP",
      skipOpeningHint: "Перематывать опенинг, когда плеер до него дойдёт.",
      skipEnding: "Пропуск ED",
      skipEndingHint: "На эндинге — сразу к следующей серии (или перемотать титры).",
      autoNext: "Автопереход",
      autoNextHint: "Когда серия закончится, включить следующую. Shift+N / Shift+P — следующая и предыдущая.",
      resume: "С места",
      resumeHint: "Открывать серию там, где вы остановились.",
      unsupported: "Этот плеер не сообщает нам, где он сейчас, — функция работает с Kodik.",
      noTimes: "Для этой серии тайминги опенинга/эндинга пока неизвестны.",
    },
    geoHint: "Если вместо видео Kodik пишет «Видео запрещено к просмотру в данной стране» — он ограничивает показ по региону. Отключите VPN (или исключите из него kodikplayer.com) и обновите страницу.",
    loadPlayer: "Запустить плеер",
    voiceover: "Озвучка / субтитры",
    switchPlayer: "Сменить плеер ({count})",
    notWorking: "Не грузится?",
    ourPlayer: "Наш плеер",
    dubs: "Озвучка",
    dubFavourite: "Отметить как любимую",
    dubFavouriteOn: "Любимая озвучка: плеер всегда открывается на ней. Нажмите, чтобы снять",
    ctl: {
      seek: "Перемотка",
      back: "Назад на {n} с",
      forward: "Вперёд на {n} с",
      volume: "Громкость",
      settings: "Настройки плеера",
      speed: "Скорость",
      speedNormal: "Обычная",
      step: "Шаг перемотки",
      stepValue: "{n} с",
      quality: "Качество",
      qualityAuto: "Авто",
      qualitySingle: "У этой серии одно качество.",
      keys: "Пробел — пауза · ← → — перемотка · M — звук · F — весь экран · Shift+< > — скорость · Shift+N — следующая серия",
    },
    tip: {
      episodesTab: "Все серии тайтла: {n}",
      dubsTab: "Озвучки и субтитры: {n}",
      episodeJump: "Введите номер и нажмите Enter — список перейдёт к этой серии",
      episodeCurrent: "Сейчас в плеере",
      episodeStarted: "Остановились на {at}",
      episodeUnmark: "Снять отметку «просмотрено»",
      dubCurrent: "{name} — сейчас играет",
      dubPick: "Переключить на {name}",
      dubEpisodes: "Серий в этой озвучке: {n}",
      dubStar: "Звёздочка — любимая озвучка: плеер будет сразу открываться на ней",
    },
    skipOpening: "Пропустить опенинг",
    autoMarked: "Серия {n} отмечена просмотренной",
    episodeOpening: "Опенинг {from}–{to}",
    episodeDubs: "Озвучек с этой серией: {n}",
    episodeNotInDub: "Нет в текущей озвучке — переключим сами",
    episodeWatched: "Просмотрено",
    skin: {
      shadow: "Тень",
      glass: "Стекло",
      accent: "Акцент",
    },
    playerOwn: "Свой плеер",
    playerProvider: "Kodik",
    playerOwnHint: "Плеер Anivora: запоминает, где вы остановились, и сам включает следующую серию.",
    playerProviderHint: "Встроенный плеер провайдера — больше озвучек, но интерфейс не наш.",
    playerOwnUnavailable: "У этого тайтла нет прямого потока — свой плеер играть нечему.",
    playerProviderUnavailable: "Для этого тайтла встроенных источников не нашлось.",
    theatre: "Во всю ширину",
    theatreExit: "Обычный размер",
    autoNext: "Следующая сама",
    findingSource: "Подбираем рабочий источник…",
    allFailedHint: "Ни один источник не откликнулся сам.",
    retry: "Попробовать снова",
    stuckModalTitle: "Видео не отвечает?",
    stuckModalBody: "Если картинка зависла или не грузится — переключим на другой источник одним нажатием.",
    stuckModalDismiss: "Всё хорошо",
    stuckModalSwitch: "Переключить источник",
    fullscreen: "На весь экран",
    exitFullscreen: "Свернуть из полноэкранного",
    play: "Смотреть",
    pause: "Пауза",
    skipBack: "Назад на 10 секунд",
    skipForward: "Вперёд на 10 секунд",
    mute: "Выключить звук",
    unmute: "Включить звук",
    speed: "Скорость",
    pip: "Окно в окне",
    stable: "стабильный",
    unstable: "нестабильный",
    stableHint: "Мы проверили: этот плеер отвечает.",
    unstableHint: "На последней проверке плеер не ответил — может не запуститься.",
    notConfigured: "Плеер сейчас недоступен.",
    notFound: "Плеер для этого тайтла не найден.",
    providerError: "Плеер не ответил. Попробуйте позже.",
    watchTrailer: "Смотреть трейлер",
    episodesCount: "{count} эп.",
    episodeOf: "Серия {episode} из {total}",
    episodeBare: "Серия {episode}",
    prevEpisode: "Предыдущая серия",
    nextEpisode: "Следующая серия",
    episodeInputLabel: "Номер серии",
    episodeHelp: "Что это",
    episodeHelpBody:
      "Плеер не может сказать нам, на какой вы серии и насколько далеко — укажите это сами. Введите номер вручную или зажмите стрелки, чтобы быстро пролистать серии.",
    comingOn: "Выходит {date}",
    days: "дн.",
    hours: "ч.",
    minutes: "мин.",
    seconds: "сек.",
    willAppearWhenOut: "Плеер появится здесь, когда аниме начнёт выходить.",
  },
  library: {
    side: {
      filters: "Фильтры",
      reset: "Сбросить",
      airing: "Сейчас выходят",
      scored: "С моей оценкой",
      withNotes: "С заметками",
      type: "Тип",
      genres: "Жанры",
      more: "Ещё…",
    },
    title: "Мой список",
    searchPlaceholder: "Поиск по названию…",
    noSearchResults: "Ничего не найдено",
    sortBy: "Сортировка",
    sort: {
      recent: "По дате",
      title: "По названию",
      score: "По оценке",
      progress: "По прогрессу",
      added: "По добавлению",
      rating: "По рейтингу",
      year: "По году",
    },
    viewGrid: "Сетка",
    viewList: "Список",
    signedOutTitle: "Здесь будет ваш список",
    signedOutBody:
      "Войдите, чтобы отмечать, что смотрите, планировать сезоны и ставить оценки завершённому.",
    countTracked: "в списке: {count}",
    nothingTracked: "Список пуст — добавьте тайтл с любой страницы аниме.",
    emptyTitle: "Список пуст",
    emptyStatusTitle: "Нет тайтлов со статусом «{status}»",
    emptyBody: "Откройте любое аниме и добавьте его через выбор статуса.",
    addToLibrary: "В список",
    watchStatus: "Статус просмотра",
    yourScore: "Ваша оценка",
    noScore: "Без оценки",
    scoreValue: "{value} / 10",
    removeFromLibrary: "Убрать «{title}» из списка",
    notesLabel: "Заметка",
    notesPlaceholder: "Почему бросили, что вспомнить перед новым сезоном…",
    notesSaved: "Заметка сохранена",
    signInToTrack: "Войдите, чтобы отслеживать",
    savedStatus: "{title} — {status}",
    removed: "«{title}» убрано из списка",
    saveError: "Не удалось сохранить изменение.",
    confirmRemoveTitle: "Убрать «{title}» из списка?",
    stats: {
      titles: "тайтлов",
      episodes: "серий",
      hours: "часов",
      avgScore: "средняя оценка",
      completed: "досмотрено",
    },
    continueTitle: "Продолжить",
    nextEpisode: "Дальше {n} серия",
    plusOne: "+1 серия",
    editEpisodes: "Нажмите, чтобы ввести число серий",
    minusOne: "−1 серия",
    finished: "«{title}» досмотрено",
    startedWatching: "«{title}» — смотрю",
    allGenres: "Все жанры",
    showing: "Показано: {count}",
    actions: "Действия",
    setScore: "Оценка",
    editNote: "Заметка",
    removeShort: "Убрать из списка",
    updated: "Изменено {when}",
    col: {
      title: "Название",
      progress: "Прогресс",
      myScore: "Моя",
      rating: "MAL",
      status: "Статус",
      updated: "Изменено",
    },
    random: {
      button: "Что посмотреть?",
      title: "Случайный выбор",
      fromPlanned: "Из «В планах» — {count}",
      fromShown: "Из показанных — {count}",
      again: "Ещё раз",
      open: "Открыть",
      empty: "Добавьте что-нибудь в список — и я выберу за вас.",
    },
    searchShortcut: "Нажмите / для поиска",
    tracker: {
      prompt: "Отметьте тайтл",
      promptHint: "Один клик — и он в вашем списке",
      rate: "Ваша оценка",
      rateHint: "Оцените",
      clearScore: "Сбросить оценку",
      episode: "Серия",
      of: "из {total}",
      noteTitle: "Личная заметка",
      noteEmpty: "Что зацепило, на чём остановились, кому посоветовать…",
      notePrivate: "Видна только вам",
      noteSaveHint: "Ctrl + Enter — сохранить",
      ratedAndAdded: "Оценка {score} — «{title}» теперь в «Просмотрено»",
      signInTitle: "Отслеживайте, что смотрите",
      signInBody: "Статусы, оценки, серии и заметки — всё в одном списке.",
      r1: "Хуже некуда",
      r2: "Ужасно",
      r3: "Очень плохо",
      r4: "Плохо",
      r5: "Средне",
      r6: "Неплохо",
      r7: "Хорошо",
      r8: "Очень хорошо",
      r9: "Великолепно",
      r10: "Шедевр",
      myList: "Мой список",
      rateTap: "Нажмите на звезду",
    },
  },
  status: {
    WATCHING: "Смотрю",
    PLANNED: "В планах",
    COMPLETED: "Просмотрено",
    ON_HOLD: "Отложено",
    DROPPED: "Брошено",
  },
  type: {
    TV: "ТВ-сериал",
    MOVIE: "Фильм",
    OVA: "OVA",
    ONA: "ONA",
    SPECIAL: "Спешл",
    MUSIC: "Клип",
    UNKNOWN: "Аниме",
  },
  airing: {
    AIRING: "Выходит сейчас",
    FINISHED: "Завершено",
    UPCOMING: "Анонс",
    UNKNOWN: "Статус неизвестен",
    airingShort: "В эфире",
  },
  season: { winter: "Зима", spring: "Весна", summer: "Лето", fall: "Осень" },
  auth: {
    welcomeBack: "С возвращением",
    welcomeBackSub: "Войдите, чтобы открыть свой список.",
    registerTitle: "Создайте аккаунт",
    registerSub: "Отмечайте, что смотрите и что хотите посмотреть.",
    email: "Эл. почта",
    password: "Пароль",
    displayName: "Отображаемое имя",
    passwordHint: "Не меньше 8 символов.",
    signInCta: "Войти",
    registerCta: "Зарегистрироваться",
    newHere: "Впервые здесь?",
    createOne: "Создать аккаунт",
    haveAccount: "Уже есть аккаунт?",
    genericError: "Что-то пошло не так. Попробуйте ещё раз.",
    orDivider: "или",
    telegramCta: "Войти через Telegram",
    couldntContinue: "Не удалось продолжить",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    emailPlaceholder: "you@example.com",
    displayNamePlaceholder: "Как вас увидят другие",
    strength: {
      weak: "Слабый пароль",
      fair: "Так себе",
      good: "Хороший пароль",
      strong: "Надёжный пароль",
      rules: {
        length: "8+ символов",
        mixedCase: "Строчные и заглавные",
        digit: "Цифра",
        symbol: "Спецсимвол",
      },
    },
    forgotPassword: "Забыли пароль?",
    verifyEmail: {
      passwordPrompt: "Введите пароль, который указали при регистрации",
      passwordWrong: "Пароль не совпадает с указанным при регистрации",
      title: "Подтвердите почту",
      subtitle: "Мы отправили 6-значный код на {email}. Введите его ниже.",
      submit: "Подтвердить",
      resend: "Отправить код ещё раз",
      resendCooldown: "Повторно можно через {seconds} сек",
      resent: "Код отправлен повторно.",
      wrongEmail: "Неверная почта? Начать заново",
      success: "Почта подтверждена!",
      invalidCode: "Неверный или просроченный код.",
      codeLabel: "Код подтверждения",
    },
    forgotPasswordPage: {
      title: "Восстановление пароля",
      subtitle: "Укажите почту — вышлем код для сброса пароля.",
      submit: "Отправить код",
      sentTitle: "Проверьте почту",
      sentBody: "Если аккаунт с {email} существует, мы отправили на него код для сброса пароля.",
      continueCta: "У меня есть код",
      backToLogin: "Назад ко входу",
    },
    resetPasswordPage: {
      title: "Новый пароль",
      subtitle: "Введите код из письма и новый пароль.",
      code: "Код из письма",
      newPassword: "Новый пароль",
      submit: "Сохранить пароль",
      success: "Пароль изменён. Теперь можно войти.",
      goToLogin: "Войти",
    },
  },
  admin: {
    x: {
      eyebrow: "Администрирование",
      todayRegistered: "{n} зарегистрированных сегодня",
      todayGuests: "{n} гостей сегодня",
      newIn30: "+{n} за 30 дней",
      allTime: "{n} за всё время",
      visitors30: "Посетители за 30 дней",
      pageviews30: "Просмотры за 30 дней",
      guestShare: "гостей {p}%",
      splitTitle: "Зарегистрированные и гости",
      splitHint: "Всё, что может сделать посетитель без аккаунта, — в двух колонках",
      registered: "Зарегистрированные",
      guests: "Гости",
      total: "Всего",
      guestPart: "Доля гостей",
      windows: { today: "Сегодня", "7d": "7 дней", "30d": "30 дней" },
      rows: {
        visitors: "Посетители",
        pageviews: "Просмотры страниц",
        animeViews: "Открытия тайтлов",
        titles: "Разных тайтлов",
        watchSessions: "Сеансы плеера",
        watchSeconds: "Время просмотра",
      },
      trendViews: "Просмотры страниц по дням",
      trendWatch: "Минуты просмотра по дням",
      trendHint: "30 дней, зарегистрированные и гости",
      topHint: "Открытия страниц и время в плеере за 30 дней — отдельно для гостей",
      title: "Тайтл",
      opens: "Открытия",
      watchReg: "Смотрели (зарег.)",
      watchGuests: "Смотрели (гости)",
      mon: {
        targetUp: "API опрашивается",
        targetDown: "API не отвечает Prometheus",
        targetMissing: "Цель animeshadow-api не настроена",
        unreachable: "Prometheus недоступен",
        lastScrape: "последний сбор {ago}",
        noData: "Данных пока нет — Prometheus собирает их каждые 15 секунд",
        setupTitle: "Prometheus не подключён",
        step1: "Установите METRICS_TOKEN и PROMETHEUS_URL в .env сервера (пустой токен допустим только локально).",
        step3: "Перезапустите API и обновите эту вкладку — графики появятся через минуту.",
        panels: {
          requests: "Запросы к API",
          latency: "Время ответа",
          errors: "Ошибки",
          pageviews: "Просмотры страниц",
          watch: "Минуты просмотра",
          active: "Сейчас на сайте",
          signups: "Регистрации и входы",
          memory: "Память API",
          cpu: "Нагрузка на CPU",
        },
        units: {
          rps: "запросов в секунду",
          ms: "миллисекунды",
          count: "за интервал",
          minutes: "минут за интервал",
          bytes: "байты",
          percent: "% одного ядра",
        },
        series: {
          total: "Всего",
          registered: "Зарегистрированные",
          guest: "Гости",
          p50: "Медиана",
          p95: "95-й перцентиль",
          "5xx": "5xx",
          "4xx": "4xx",
          registrations: "Регистрации",
          logins: "Входы",
          rss: "RSS",
          heap: "Heap",
          cpu: "CPU",
        },
      },
    },
    activeToday: "{count} активны сегодня",
    tabHints: {
      dashboard: "Трафик, аудитория, топы",
      users: "Кто, когда, что смотрит",
      comments: "Модерация обсуждений",
    },
    title: "Панель управления",
    subtitle: "Трафик, аудитория, контент и модерация Anivora — в одном месте.",
    updated: "Обновлено в",
    refresh: "Обновить",
    undo: "Отменить",
    empty: "Пока нет данных",
    last30: "за 30 дней",
    tabs: {
      analytics: "Аналитика",
      overview: "Обзор",
      monitoring: "Мониторинг",
      parties: "Комнаты",
      dashboard: "Дашборд",
      users: "Пользователи",
      pro: "PRO",
      comments: "Комментарии",
      reports: "Жалобы",
      news: "Новости",
    },
    units: { h: "ч", m: "мин" },
    range: { d7: "7 дн.", d14: "14 дн.", d30: "30 дн." },
    kpi: {
      users: "Пользователи",
      visitors: "Уникальные посетители",
      pageviews: "Просмотры страниц",
      watchTime: "Время просмотра",
      comments: "Комментарии",
      new: "новое",
      thisPeriod: "30 дней",
      prevPeriod: "прошлые 30",
    },
    metrics: {
      pageviews: "Просмотры",
      visitors: "Посетители",
      registrations: "Регистрации",
      watchMinutes: "Минуты просмотра",
    },
    traffic: {
      title: "Динамика сайта",
      description: "Ежедневная активность за выбранный период",
      mode: { traffic: "Трафик", registrations: "Регистрации", watch: "Просмотр аниме" },
    },
    audience: {
      title: "Аудитория",
      description: "Доли от всех аккаунтов",
      accounts: "аккаунтов",
      newUsers: "Новые за 30 дней",
      telegram: "Через Telegram",
      admins: "Администраторы",
      banned: "Заблокированы",
      activeToday: "Посетителей сегодня",
    },
    library: {
      title: "Статусы в списках",
      description: "Как пользователи отмечают тайтлы",
      entries: "записей",
    },
    genres: {
      title: "Любимые жанры",
      description: "По тайтлам в списках пользователей",
      titles: "Тайтлов в списках",
    },
    hours: {
      title: "Активность по часам",
      description: "Просмотры страниц за 7 дней, по вашему времени",
      peak: "Пик активности",
    },
    topAnime: {
      title: "Топ аниме на сайте",
      description: "Самые просматриваемые страницы тайтлов",
      views: "Просмотры страницы",
      watchers: "Зрители",
    },
    referrers: {
      title: "Источники регистраций",
      description: "Откуда пришли зарегистрированные пользователи",
      direct: "Прямой заход",
      unknown: "Неизвестно",
      other: "Другие",
    },
    pages: {
      title: "Популярные страницы",
      description: "Просмотры за последние 30 дней",
    },
    recentUsers: { title: "Новые пользователи", description: "Последние регистрации" },
    recentComments: {
      title: "Свежие комментарии",
      description: "Последнее, что написали на сайте",
      on: "к",
    },
    pager: { shown: "Показано", of: "из", prev: "Назад", next: "Вперёд" },
    users: {
      searchPlaceholder: "Поиск по имени или email…",
      roleAll: "Все роли",
      roleUser: "Пользователь",
      roleAdmin: "Администратор",
      statusAll: "Любой статус",
      statusActive: "Активен",
      statusBanned: "Заблокирован",
      sortNewest: "Сначала новые",
      sortOldest: "Сначала старые",
      sortName: "По имени",
      columns: {
        user: "Пользователь",
        activity: "Активность",
        joined: "Регистрация",
        role: "Роль",
        status: "Статус",
      },
      you: "вы",
      telegramAccount: "Аккаунт Telegram",
      comments: "Комментарии",
      library: "Тайтлов в списке",
      emptyTitle: "Никого не найдено",
      emptyBody: "Попробуйте изменить поиск или фильтры.",
      roleChanged: "Роль обновлена",
      bannedToast: "Пользователь заблокирован",
      unbannedToast: "Пользователь разблокирован",
      sortLastSeen: "Недавно заходили",
      sortComments: "Больше комментариев",
      sortLibrary: "Больше тайтлов",
      lastSeen: "Был(а)",
      watchTime: "Просмотр",
      online: "онлайн",
      never: "не заходил(а)",
      open: "Открыть карточку",
      hint: "Нажмите на пользователя, чтобы увидеть всё о нём и управлять аккаунтом.",
    },
    user: {
      tabs: { overview: "Обзор", library: "Список", comments: "Комментарии", activity: "Активность" },
      makeAdmin: "Сделать админом",
      removeAdmin: "Снять админа",
      ban: "Заблокировать",
      unban: "Разблокировать",
      setPassword: "Сменить пароль",
      copyEmail: "Скопировать email",
      copyId: "Скопировать ID",
      copied: "Скопировано",
      openProfile: "Открыть профиль",
      selfNote: "Это вы — роль и блокировку себе поменять нельзя.",
      stats: {
        watch: "Время просмотра",
        sessions: "Сессий просмотра",
        pageviews30: "Страниц за 30 дней",
        activeDays: "Активных дней из 30",
        library: "Тайтлов в списке",
        comments: "Комментариев",
        likes: "Лайков получено",
        achievements: "Ачивок",
      },
      activityChart: "Активность за 30 дней",
      pagesLegend: "страниц",
      watchLegend: "мин просмотра",
      account: "Аккаунт",
      facts: {
        loginEmail: "Email для входа",
        username: "Ник",
        registered: "Регистрация",
        lastSeen: "Последний визит",
        emailVerified: "Email подтверждён",
        ageVerified: "Возраст подтверждён",
        pro: "PRO",
        telegram: "Telegram",
        referrer: "Пришёл(а) с",
        status: "Статус в профиле",
        bio: "О себе",
      },
      yes: "да",
      no: "нет",
      direct: "прямой заход",
      topWatched: "Больше всего смотрит",
      noWatch: "Ещё ничего не смотрел(а) в плеере.",
      recentLibrary: "Недавно в списке",
      noLibrary: "Список пуст.",
      noComments: "Комментариев нет.",
      deletedComment: "удалён",
      deleteComment: "Удалить комментарий",
      commentDeleted: "Комментарий удалён",
      recentPages: "Последние страницы",
      noPages: "Посещений пока не записано.",
      loadError: "Не удалось загрузить пользователя.",
      password: {
        title: "Новый пароль",
        body: "Пользователь сможет сразу войти с этим паролем. Текущий пароль перестанет работать.",
        label: "Пароль",
        placeholder: "Минимум 8 символов",
        generate: "Сгенерировать",
        show: "Показать",
        hide: "Скрыть",
        tooShort: "Минимум 8 символов",
        save: "Установить пароль",
        doneTitle: "Пароль установлен",
        doneBody: "Передайте пользователю данные для входа:",
        loginLabel: "Логин (email)",
        copyBoth: "Скопировать логин и пароль",
        close: "Готово",
        telegramNote: "Это аккаунт Telegram — у него служебный email, по нему тоже можно войти.",
      },
    },
    reports: {
      statusOpen: "Ждут решения",
      statusResolved: "Приняты меры",
      statusDismissed: "Отклонённые",
      statusAll: "Все жалобы",
      profilesTab: "Жалобы на профили",
      episodesTab: "Проблемы с сериями",
      episodeEmptyTitle: "Жалоб пока нет",
      episodeEmptyBody: "Сообщения о проблемах с эпизодами появятся здесь.",
      episodeSource: "Источник: {provider} · {name} · {time}",
      episodeFixed: "Исправлено",
      episodeClose: "Закрыть",
      episodeOpenAnime: "Открыть аниме",
      episodeReasons: {
        no_video: "Видео не запускается",
        wrong_episode: "Открывается другая серия",
        audio_or_subtitles: "Звук или субтитры",
        other: "Другая проблема",
      },
      emptyTitle: "Жалоб нет",
      emptyBody: "Когда кто-то пожалуется на профиль, он появится здесь.",
      complaints: "Жалоб: {n}",
      open: "{n} ждут решения",
      noBio: "Описания нет",
      banned: "Заблокирован",
      admin: "Админ",
      openProfile: "Открыть профиль",
      openUser: "Карточка пользователя",
      measuresTitle: "Что сделать",
      notePlaceholder: "Заметка для других админов (необязательно)",
      takeMeasures: "Принять меры",
      dismiss: "Отклонить",
      pickMeasure: "Выберите хотя бы одну меру",
      confirmTitle: "Принять эти меры?",
      confirmBody: "Все открытые жалобы на этот профиль закроются.",
      confirmBan: "Аккаунт будет заблокирован и разлогинен везде.",
      resolvedToast: "Готово — жалобы закрыты",
      dismissedToast: "Жалобы отклонены",
      decisionResolved: "Приняты меры",
      decisionDismissed: "Отклонено",
      from: "от {name}",
      reasons: {
        spam: "Спам или реклама",
        abuse: "Оскорбления или травля",
        content: "Недопустимые аватар, обложка или описание",
        impersonation: "Выдаёт себя за другого",
        other: "Другое",
      },
      measures: {
        avatar: "Сбросить аватар",
        banner: "Убрать обложку",
        bio: "Очистить «о себе»",
        wall: "Удалить его записи на стенах",
        ban: "Заблокировать аккаунт",
      },
      done: {
        avatar: "аватар сброшен",
        banner: "обложка убрана",
        bio: "описание очищено",
        wall: "записи удалены",
        ban: "заблокирован",
      },
    },
    comments: {
      searchPlaceholder: "Поиск по тексту комментария…",
      statusAll: "Все комментарии",
      statusActive: "Опубликованные",
      statusReported: "С жалобами",
      statusDeleted: "Удалённые",
      sortNewest: "Сначала новые",
      sortOldest: "Сначала старые",
      sortTop: "Самые залайканные",
      columns: {
        author: "Автор",
        anime: "Аниме",
        comment: "Комментарий",
        reactions: "Реакции",
        date: "Дата",
      },
      deleted: "Удалён",
      anon: "Анонимно",
      supporter: "Донатер",
      actions: "Действия",
      openAnime: "Открыть аниме",
      delete: "Удалить",
      emptyTitle: "Комментариев не найдено",
      emptyBody: "Попробуйте изменить поиск или фильтры.",
      confirmDeleteTitle: "Удалить комментарий?",
      confirmDeleteBody: "Текст скроется у всех. Это действие нельзя отменить.",
      deletedToast: "Комментарий удалён",
    },
  },
  command: {
    placeholder: "Искать аниме по названию…",
    typeMore: "Введите хотя бы два символа.",
    searching: "Ищем…",
    noMatches: "Ничего не найдено.",
    animeGroup: "Аниме",
    goTo: "Перейти",
  },
  search: {
    hintTitle: "Поиск аниме",
    hintCollections: "Поиск подборок",
    placeholder: "Название аниме или персонаж…",
    modeAnime: "Аниме",
    modeCollections: "Подборки",
    searchedNow: "Сейчас ищут",
    watchedNow: "Сейчас смотрят",
    popularGenres: "Популярные жанры",
    genreTop: "Популярное: {genre}",
    genreAll: "Весь жанр «{genre}» в каталоге",
    popularCollections: "Популярные подборки",
    collectionsFound: "Подборки",
    collectionsNone: "Подборок не нашлось.",
    collectionsAll: "Все подборки по «{query}»",
    collectionMeta: "{n} аниме · {author}",
    typeMore: "Продолжайте вводить…",
    searching: "Ищем",
    noMatches: "По запросу ничего не нашлось.",
    seeAll: "Показать все результаты по «{query}»",
    seeMore: "Показать ещё по «{query}»",
    recent: "Недавнее",
    forYou: "Для вас",
    groupTitle: "По названию",
    groupCharacter: "Персонаж: {name}",
    groupStudio: "Студия: {name}",
    groupMood: "По настроению",
    groupSynopsis: "Найдено в описании",
    detectedAs: "Понято как: {genres}",
    open: "Открыть поиск",
    smartSearch: "умный поиск",
  },
  errors: {
    genericTitle: "Не удалось загрузить",
    genericBody: "Что-то пошло не так при загрузке. Обычно это временно.",
    offline: "Не удаётся связаться с сервером. Проверьте соединение и повторите.",
    pageSnag: "На этой странице возникла проблема",
    backToDiscover: "Вернуться к обзору",
    notFoundTitle: "Страница не найдена",
    notFoundBody: "Такой страницы нет или она была перемещена.",
  },
  support: {
    eyebrow: "Поддержка",
    safeNote: "Оплата через Boosty — мы не видим данных карты",
    previewTitle: "Так выглядит PRO",
    previewName: "Ваш ник",
    previewBody: "Значок Anivora после ника — в профиле, в комментариях и везде, где вас видят.",
    steps: {
      title: "Как включается PRO",
      pickTitle: "Выберите срок",
      pickBody: "1 месяц, 3 месяца или год — чем дольше, тем дешевле месяц. Способ оплаты выбирается на странице оплаты.",
      tellTitle: "Напишите нам логин",
      doneTitle: "Печать у вашего ника",
      doneBody: "PRO включается вручную в течение суток — и рядом с ником появляется значок Anivora.",
    },
    title: "Поддержка проекта",
    lead: "Anivora бесплатен и остаётся таким. PRO и донаты — необязательный бонус: способ сказать спасибо и получить пару приятных мелочей.",
    plansTitle: "Подписка",
    free: {
      name: "Бесплатно",
      price: "$0",
      period: "",
      tagline: "Всё основное — навсегда бесплатно.",
    },
    pro: {
      name: "PRO",
      price: "$5",
      period: "/мес",
      tagline: "Для тех, кто смотрит много.",
      badge: "Рекомендуем",
    },
    feat: {
      catalog: "Полный каталог и поиск",
      list: "Список просмотра и оценки",
      progress: "Прогресс по эпизодам",
      reviews: "Комментарии сообщества",
      resume: "Продолжение просмотра на всех устройствах",
      unlimited: "Безлимитный список",
      hd: "Приоритет HD-источников",
      badge: "Значок Anivora у ваших комментариев",
      early: "Ранний доступ к новым фичам",
    },
    currentPlan: "Ваш текущий план",
    getPro: "Оформить PRO на Boosty",
    boosty: {
      title: "Поддержать на Boosty",
      body: "Разовый донат или подписка — платёж проходит через Boosty, мы не храним данные карты. Сумму и способ оплаты выбираете уже на их странице.",
      cta: "Перейти на Boosty",
      proNote:
        "Оформили PRO на Boosty? Напишите нам логин — включим PRO вручную в течение суток.",
    },
    tiers: {
      t1Name: "Зритель",
      t1Perk: "Имя в списке благодарности на Boosty",
      t2Name: "Оператор",
      t2Perk: "PRO на месяц + значок Anivora у ника",
      t3Name: "Режиссёр",
      t3Perk: "Всё выше + голос в планах развития",
    },
  },
  about: {
    eyebrow: "О проекте",
    steps: {
      catalogTitle: "Каталог из открытых баз",
      catalogBody: "Названия, описания, жанры и рейтинги собираются из открытых баз данных и переводятся на русский.",
      videoTitle: "Видео — у плееров",
      videoBody: "Серии показывают сторонние плееры. Мы ничего не храним и не раздаём — только встраиваем.",
      listTitle: "Список — ваш",
      listBody: "Статусы, оценки и прогресс по сериям хранятся у нас и переезжают с вами на любое устройство.",
    },
    title: "О проекте",
    lead: "Anivora — тёмный тихий зал: интерфейс уходит в тень, весь свет достаётся постеру.",
    introBody:
      "Делаем его, потому что задолбались от перегруженных аниме-сайтов с рекламой на каждом углу. Один каталог на русском, свой список, прогресс по сериям и живые отзывы — регистрация нужна только для списка, смотреть можно и без неё.",
    featuresTitle: "Что внутри",
    features: {
      catalogTitle: "Каталог на русском",
      catalogBody: "Названия и описания сразу на русском — без гугл-перевода.",
      trackTitle: "Список и прогресс",
      trackBody: "Статус, оценка, продолжить с той же серии — в один клик.",
      playerTitle: "Встроенный плеер",
      playerBody: "Есть источник — смотрите прямо на странице, без переходов.",
      calmTitle: "Ничего лишнего",
      calmBody: "Один спокойный экран. Ни баннеров, ни всплывающих окон.",
    },
    howTitle: "Как это работает, без магии",
    howBody:
      "Каталог — из открытых баз данных об аниме. Видео берём у сторонних плееров, сами ничего не храним.",
    supportTitle: "Помочь проекту",
    supportBody:
      "Сервера и трафик стоят реальных денег, а разработка — это вечера и выходные одного человека. Никакой рекламы и платных стен — только добровольный донат через Boosty. Даже 100 рублей — это уже вклад в то, чтобы сайт жил дальше.",
    supportCta: "Поддержать на Boosty",
    ctaTitle: "Ну что, погнали?",
    ctaButton: "Открыть каталог",
  },
  recommendations: {
    youAreHere: "Вы здесь",
    save: "Сохранить",
    saved: "Сохранено",
    openTitle: "Открыть тайтл",
    eyebrow: "Рекомендации",
    title: "Настройте, что вам показывать",
    lead: "Выберите тайтл — покажем похожее; выберите из него следующий, и цепочка пойдёт дальше. Сердечко сохраняет тайтл: именно по сохранённым главная и блок «вам может понравиться» подбирают рекомендации.",
    searchPlaceholder: "Найти аниме, чтобы начать…",
    searchResults: "Результаты поиска",
    likedHeading: "Сохранённое ({count})",
    likedEmpty: "Пока пусто — отметьте сердечком то, что понравилось.",
    popularHeading: "Популярное",
    startHeading: "С чего начнём?",
    startBody: "Выберите любой тайтл, который вам нравится — дальше подборка пойдёт от него.",
    similarTo: "Похоже на «{title}»",
    walkHint: "Выберите следующий — и цепочка пойдёт дальше уже от него.",
    noSimilar: "Похожего не нашлось. Вернитесь на шаг назад или начните с другого тайтла.",
    trailLabel: "Ваш путь",
    restart: "Начать заново",
    walkTo: "Показать похожее на «{title}»",
    showSimilar: "Похожее",
    openPage: "Открыть страницу «{title}»",
    like: "Отметить «{title}» как понравившееся",
    unlike: "Убрать «{title}» из понравившихся",
    genreHint: "Любимые жанры без привязки к конкретным тайтлам можно выбрать в",
    menuNudge: "Настроить рекомендации",
    signedOutTitle: "Нужен аккаунт",
    signedOutBody: "Войдите, чтобы отмечать понравившиеся тайтлы и настраивать подборку под себя.",
  },
  frameSearch: {
    bestMatch: "Лучшее совпадение",
    navLabel: "Поиск по кадру",
    quickSearchHint: "Найти аниме по скриншоту, видео или ссылке TikTok",
    beta: "Бета",
    betaNote: "Тестовая функция — срабатывает не всегда. Поиск идёт через внешний сервис trace.moe с общим ограниченным лимитом запросов, поэтому иногда придётся попробовать позже.",
    errorQuota: "Лимит поиска по кадру на этот месяц исчерпан. Попробуйте в следующем месяце.",
    errorBusy: "Прямо сейчас кто-то уже ищет по кадру — сервис принимает один запрос за раз. Попробуйте через минуту.",
    errorUnavailable: "Сервис поиска по кадру сейчас не отвечает. Попробуйте чуть позже.",
    errorTimeout: "Поиск занял слишком много времени и был остановлен. Попробуйте ещё раз.",
    tipsTitle: "Какой кадр подойдёт",
    tips: {
      fromEpisode: "Скриншот прямо из серии — не постер, не обложка и не фан-арт",
      wholeFrame: "Кадр целиком, без сильной обрезки",
      sharp: "Чёткий, без размытия и сильного сжатия",
      noOverlay: "По возможности без субтитров и интерфейса плеера",
      screenshot: "Именно скриншот, а не фото экрана на телефон",
    },
    examplesTitle: "Примеры",
    examples: {
      fullFrame: "Полный чёткий кадр из серии — то, что нужно",
      blurry: "Размытый или пережатый",
      overlay: "Субтитры и интерфейс плеера поверх",
      cropped: "Слишком сильно обрезан",
      photo: "Фото экрана, а не скриншот",
      poster: "Постер или обложка — их нет в базе",
    },
    eyebrow: "Поиск по кадру",
    title: "Что это за аниме?",
    lead: "Загрузите скриншот или выберите кадр из видео, вставьте ссылку на TikTok — и мы попробуем найти аниме, серию и момент.",
    dropHint: "Перетащите картинку сюда",
    pasteHint: "или вставьте из буфера — Ctrl+V",
    videoTooLarge: "Выбери видео размером до 100 МБ. Само видео останется на устройстве.",
    imageTooLarge: "Выбери изображение до 20 МБ.",
    videoNotReady: "Дождись загрузки видео и выбери кадр.",
    videoCaptureUnsupported: "Не удалось извлечь кадр в этом браузере.",
    videoCaptureFailed: "Не удалось извлечь кадр. Попробуй другой момент видео.",
    videoFrameHint: "Поставь видео на паузу на кадре с аниме и нажми кнопку. Видео останется на устройстве — на сервер отправится только выбранный кадр.",
    videoSearch: "Искать по выбранному кадру",
    tiktokLabel: "Или вставь ссылку на TikTok-видео",
    tiktokSearch: "Искать по TikTok",
    tiktokHint: "Сначала проверим обложку TikTok. Если на ней нет чёткого кадра из серии, загрузи скриншот или видео — кадр извлечётся прямо в браузере.",
    searchAction: "Найти аниме и серию",
    searchWorking: "Ищем аниме…",
    mirror: "Отразить кадр по горизонтали",
    searchCaveat: "Если совпадений нет, проверим зеркальный вариант. Сильные фильтры и крупные надписи могут помешать; серию показываем только из ответа сервиса.",
    dropVideoHint: "Перетащи сюда скриншот или видео",
    pickFile: "Выбрать файл",
    reset: "Сбросить",
    searching: "Ищем кадр…",
    noMatches: "Совпадений не нашлось. Попробуйте кадр покрупнее и без чёрных полос по краям.",
    resultsHeading: "Похоже, это",
    framesSearched: "Сравнили с {count} кадров",
    episodeAt: "Серия {episode} · {time}",
    atTime: "На {time}",
    openPage: "Открыть страницу",
    notInCatalogue: "Этого тайтла пока нет в нашем каталоге.",
    playMoment: "Проиграть момент",
    errorNotImage: "Выбери изображение или видео со сценой из аниме.",
    errorTooLarge: "Картинка слишком большая — до 4 МБ.",
    signedOutTitle: "Нужен аккаунт",
    signedOutBody: "Войдите, чтобы искать аниме по кадру.",
  },
  profile: {
    rhythm: {
      title: "Ритм · 14 дней",
      episodes: "{n} серий",
      record: "Рекордный день",
      session: "Средний сеанс",
      min: "мин",
    },
    hall: {
      title: "Зал трофеев",
      showcase: "Витрина",
      next: "Ближайшие",
      all: "Все",
      empty: "Пока пусто — первое достижение откроется с первой просмотренной серией.",
      pin: "Закрепить у имени",
      unpin: "Открепить",
      pinHint: "У имени: {n} из {max}",
      left: "осталось {n}",
    },
    taste: {
      title: "ДНК вкуса",
      persona: "Тип зрителя",
      match: "Совпадение вкусов с вами",
      matchHigh: "Смотрите почти одно и то же — загляните в его список.",
      matchMid: "Есть общее, есть и новое для вас.",
      matchLow: "Вкусы разные — отличный повод найти что-то новое.",
      mixOwn: "Подборка из моих жанров",
      mixTheirs: "Подборка из этих жанров",
      personas: {
        action: "Адреналинщик",
        adventure: "Путешественник",
        comedy: "Весельчак",
        mystery: "Сыщик",
        drama: "Драматург",
        fantasy: "Мечтатель",
        historical: "Летописец",
        horror: "Бесстрашный",
        magic: "Чародей",
        martial: "Мастер клинка",
        mecha: "Пилот мехи",
        music: "Меломан",
        romance: "Романтик",
        school: "Вечный школьник",
        scifi: "Футурист",
        shounen: "Сёнэн в душе",
        space: "Звездоплаватель",
        sports: "Чемпион",
        sliceOfLife: "Созерцатель",
        supernatural: "Мистик",
        military: "Стратег",
        psychological: "Психолог",
        thriller: "Нервы из стали",
        seinen: "Ценитель",
        seeker: "Искатель",
      },
    },
    progressBar: {
      title: "Полоса прогресса",
      shows: "Показывает:",
      toEpisodes: "До {n} серий",
      toTitles: "До {n} досмотренных тайтлов",
      achievements: "Открыто достижений",
      hoursShort: "ч",
      styles: {
        classic: "Классика",
        fire: "Огонь",
        shadow: "Тень",
        sparks: "Искры",
        neon: "Неон",
        sakura: "Сакура",
        ice: "Лёд",
      },
      metrics: {
        rank: "Ранг",
        episodes: "Серии",
        titles: "Тайтлы",
        achievements: "Достижения",
      },
    },
    studio: {
      open: "Настроить",
      title: "Настройка профиля",
      hint: "Всё, что меняет профиль, — здесь, в одном месте.",
      mediaHint: "Аватар и фон меняются прямо в шапке профиля: наведите на них.",
      tabs: {
        look: "Внешний вид",
        blocks: "Блоки",
        privacy: "Приватность",
        account: "Аккаунт",
        list: "Перенос списка",
      },
    },
    side: {
      earnedShare: "{n}% всех достижений",
      next: "Ближе всего к открытию",
    },
    blocks: {
      quickFromRated: "Из ваших высших оценок",
      quickAll: "Добавить все",
      quickChoose: "Выбрать вручную",
      topRated: "Высшие оценки",
      showcase: "Моя пятёрка",
      watching: "Сейчас смотрит",
      year: "Год в аниме",
      activity: "Активность",
      library: "Список",
      compare: "Совпадение вкусов",
      customise: "Настроить профиль",
      done: "Готово",
      editorHint: "Порядок блоков — стрелками, глаз — показать или скрыть. Так профиль увидят все.",
      up: "Выше",
      down: "Ниже",
      show: "Показать блок",
      hide: "Скрыть блок",
      autoAccent: "Цвет профиля из аватарки",
      autoAccentHint: "Акцент профиля возьмётся из цветов вашей аватарки",
      saved: "Профиль сохранён",
      showcaseEmpty: "Выберите до пяти любимых тайтлов — они встанут в начало профиля.",
      showcasePick: "Моя пятёрка",
      showcasePickHint: "Выбрано {n} из 5. Порядок — в порядке нажатия.",
      search: "Найти в списке…",
      watchingEmpty: "Пока ничего не смотрится.",
      continue: "Продолжить",
      listEmpty: "В этом разделе пусто.",
      openList: "Весь список",
      plusEp: "+1 серия",
      minusEp: "−1 серия",
    },
    year: {
      episodes: "серий",
      hours: "часов",
      titles: "досмотрено",
      activeDays: "дней с просмотром",
      streak: "дней подряд — рекорд",
      genre: "главный жанр",
      cell: "серий: {n}",
      busiest: "Самый насыщенный день — {day}: {n} серий",
      quiet: "В этом году просмотров ещё не было",
    },
    feed: {
      filter: {
        all: "Всё",
        episode: "Серии",
        completed: "Досмотрено",
        rated: "Оценки",
        added: "Добавлено",
        achievement: "Достижения",
      },
      episode: "Посмотрел(а) серию {n}",
      completed: "Досмотрел(а)",
      rated: "Оценил(а) на {n}",
      added: "Добавил(а) в список",
      achievement: "Получено достижение",
      more: "Показать ещё {n}",
      less: "Свернуть",
    },
    compare: {
      with: "совпадение с {name}",
      shared: "Общих тайтлов в списках: {n}",
      none: "Общих тайтлов пока нет.",
      legend: "Слева — ваша оценка, справа — оценка владельца профиля.",
    },
    privacy: {
      title: "Приватность",
      hint: "Кто видит каждую часть профиля. Вы сами видите всё.",
      list: "Список",
      stats: "Статистика и год",
      activity: "Лента активности",
      watching: "Сейчас смотрю",
      public: "Все",
      users: "Вошедшие",
      private: "Только я",
    },
    portability: {
      title: "Перенос списка",
      hint: "Скачайте список или загрузите его из MyAnimeList или Shikimori.",
      exportJson: "Скачать JSON",
      exportMal: "Скачать для MyAnimeList",
      import: "Загрузить файл",
      importAs: "Формат файла",
      formatMal: "MyAnimeList (XML)",
      formatShikimori: "Shikimori (JSON)",
      formatOwn: "Anivora (JSON)",
      importing: "Загружаем список…",
      imported: "Импортировано: {imported} из {total}. Пропущено: {skipped}.",
      failed: "Не удалось прочитать файл",
    },
    accent: {
      title: "Цвет профиля",
      hint: "Акцент вашего профиля: кнопки, рамки, подсветка.",
      reset: "Как у сайта",
    },
    settingsSearch: "Найти настройку…",
    settingsNothing: "Такой настройки нет.",
    title: "Профиль",
    tabs: {
      profile: "Профиль",
      progress: "Список аниме",
      settings: "Настройки",
      achievements: "Достижения",
      stats: "Статистика",
    },
    overview: {
      activity: "Моя активность",
      activityEmpty: "Пока пусто. Начните смотреть — история появится здесь сама.",
      recent: "Недавно просмотренное",
      recentEmpty: "Ничего не начато. Откройте любой тайтл и нажмите «Смотреть».",
      collection: "Коллекция",
      collectionEmpty: "Список пуст.",
      more: "Ещё",
      customize: "Кастомизация профиля",
      customizeHint: "Аватар, фон, цвет имени",
      customizeCta: "Настроить",
      favGenres: "Любимые жанры",
      premiumTitle: "Твой путь в мир аниме только начинается",
      premiumBody: "Больше возможностей, выше качество, без рекламы.",
      premiumCta: "Узнать больше",
      episodeOf: "Серия {n}",
      ep: {
        watched: "Посмотрел {n} серию",
        completed: "Завершил просмотр",
        added: "Добавил в список",
        rated: "Оценил на {score}",
        achievement: "Получил достижение",
      },
    },
    signedOut: {
      title: "Здесь будет ваш профиль",
      body: "Войдите, чтобы видеть прогресс просмотра, достижения и личные настройки.",
      cta: "Войти",
    },
    handle: "@{username}",
    editProfile: "Редактировать профиль",
    cosmetics: {
      frames: "Рамка аватара",
      titles: "Приписка",
      noneFrame: "Без рамки",
      noneTitle: "Без приписки",
      locked: "Откроется за «{achievement}»",
      frameNames: {
        none: "Без рамки",
        sakura: "Сакура",
        ember: "Уголёк",
        midnight: "Полночь",
        tide: "Прилив",
        marathon: "Марафон",
        inkwell: "Тушь",
        archive: "Архив",
        spectrum: "Спектр",
        eclipse: "Затмение",
        aurum: "Аурум",
        spark: "Искра",
        jade: "Нефрит",
        amethyst: "Аметист",
        inferno: "Инферно",
        celestial: "Небесная",
        sovereign: "Сюзерен",
        aurora: "Аврора",
      },
      titleNames: {
        "thousand-episodes": "Хранитель историй",
        "three-thousand-episodes": "Летописец",
        "ten-series": "Собиратель финалов",
        "twenty-five-series": "Знаток историй",
        "fifty-series": "Проводник по мирам",
        "review-explorer": "Ценитель",
        "collection-architect": "Архитектор подборок",
        "collection-library": "Искатель жемчужин",
        "curator-crowd": "Вдохновитель",
        "century-comments": "Собеседник",
        "guess-century": "Знаток кадров",
        "genre-master": "Мастер жанра",
        newcomer: "Новенький",
        "first-steps": "Первые шаги",
        "night-watch": "Ночной дозор",
        "serial-viewer": "Серийный зритель",
        marathoner: "Марафонец",
        "sharp-tongue": "Острый язык",
        archivist: "Архивариус",
        "genre-sage": "Знаток жанров",
        completionist: "Перфекционист",
        "old-guard": "Старая гвардия",
        patron: "Меценат",
        regular: "Завсегдатай",
        "season-veteran": "Ветеран сезонов",
        "shadow-lord": "Владыка теней",
        benefactor: "Покровитель",
        "guide": "Проводник",
        "spark-bearer": "Искра",
        "ambassador": "Посол",
        "community-legend": "Легенда сообщества",
        "star": "Звезда",
        "secret-ghoul": "Гуль",
        "secret-shinigami": "Синигами",
        "secret-scout": "Разведкорпус",
        "secret-hokage": "Будущий Хокаге",
        "secret-pirate": "Король пиратов",
        "secret-alchemist": "Алхимик",
        "secret-scientist": "Безумный учёный",
        "secret-hero": "Герой ради забавы",
        "secret-slayer": "Истребитель демонов",
        "secret-sorcerer": "Маг",
        "secret-devil": "Охотник на дьяволов",
        "secret-pilot": "Пилот Евы",
        "secret-hunter": "Охотник",
        "secret-spirit": "Безликий",
      },
    },
    memberSince: "с {date}",
    proMark: "Премиум-аккаунт Anivora",
    modal: {
      open: "Открыть профиль",
      commentLikes: "Лайков к комментариям",
      commenterRank: "{likes} · #{rank} из {total}",
    },
    presence: {
      online: "Онлайн",
      offline: "Оффлайн",
      dnd: "Не беспокоить",
    },
    rank: {
      label: "Ранг",
      hint: "Растёт вместе с часами просмотра: Новичок — с самого начала, Продвинутый — от 10 часов, Эксперт — от 100 часов, Легенда — от 500 часов.",
      novice: "Новичок",
      advanced: "Продвинутый",
      expert: "Эксперт",
      legend: "Легенда",
    },
    progressCard: {
      episodesOfTotal: "{done}/{total} серий ({percent}%)",
      totalTime: "Общее время: {time}",
      currentSession: "Текущая сессия: {time}",
      stoppedAt: "Остановились на {time} серии {ep}",
      untilEnd: "До конца серии: {time}",
      markWatched: "Отметить серию просмотренной",
      delete: "Удалить из истории",
      deleteTitle: "Удалить из истории просмотра?",
      deleteBody: "«{title}» пропадёт из прогресса и истории просмотра. Это можно отменить, просто начав смотреть заново.",
      deleted: "Удалено из истории просмотра",
    },
    summary: {
      totalEpisodes: "Всего серий",
      totalTime: "Всего времени",
      mostProductiveDay: "Самый продуктивный день",
      avgPerSession: "Среднее за сессию",
      durationDHM: "{d} дн {h} ч {m} м",
      durationHM: "{h} ч {m} м",
      hoursShort: "{hours} ч. в сумме",
      minutesShort: "{minutes} мин",
      topGenres: "Топ жанров",
      topRated: "Топ по вашей оценке",
      libraryChart: "Список по статусам",
      activityChart: "Просмотр за 2 недели",
      minutesAxis: "Минут",
      episodesAxis: "Серий",
      chartsEmpty: "Добавьте тайтлы в список — здесь появятся графики.",
      inProgress: "Смотрю сейчас",
      completedTitles: "Тайтлов просмотрено",
      meanScore: "Средняя оценка",
      lastWatched: "Последний просмотр",
    },
    progress: {
      freeLimit: "Без PRO отслеживаются только {count} последних тайтлов. С PRO — сколько угодно.",
      searchPlaceholder: "Поиск по названию…",
      filterAll: "Все",
      filterWatching: "Смотрю",
      filterCompleted: "Завершено",
    },
    crop: {
      avatarTitle: "Кадрирование аватарки",
      bannerTitle: "Кадрирование фона",
      hint: "Перетащите, чтобы выбрать часть; колесо или щипок — масштаб",
      zoom: "Масштаб",
      zoomIn: "Приблизить",
      zoomOut: "Отдалить",
      reset: "Сбросить",
      apply: "Сохранить",
    },
    card: {
      nextRank: "До ранга «{rank}»",
      maxRank: "Высший ранг достигнут",
      hoursLeft: "ещё {hours} ч",
      meanScore: "средняя оценка",
      likes: "лайков",
      favGenres: "Любимые жанры",
    },
    editBanner: "Изменить фон",
    settings: {
      avatar: "Аватар",
      avatarUpload: "Загрузить (JPG/PNG, до 5 МБ)",
      avatarRandom: "Случайная гифка вместо фото",
      avatarRandomDone: "Новый аватар готов",
      fileTooLarge: "Файл больше 5 МБ",
      banner: "Фон профиля",
      bannerHint: "Широкая картинка за аватаркой. Лучше всего 1500×500 и больше.",
      bannerUpload: "Загрузить своё",
      bannerRandom: "Случайный из аниме",
      bannerRandomDone: "Фон из «{title}»",
      bannerRemove: "Убрать фон",
      bannerRemoved: "Фон убран",
      bannerNone: "Фон не выбран",
      imageTypes: "JPG, PNG, WebP или GIF, до 5 МБ",
      save: "Сохранить",
      bio: "Описание профиля",
      bioHint: "до 500 символов",
      status: "Статус",
      statusHint: "«Не беспокоить» скрывает индикатор «онлайн» для других пользователей — сайт при этом работает как обычно.",
      appearance: "Оформление",
      theme: "Тема",
      themeLight: "Светлая",
      themeDark: "Тёмная",
      themeAuto: "Авто",
      showcase: "Значок в профиле",
      showcaseHint: "Выберите до 3 полученных наград, чтобы закрепить их под именем — любой сможет кликнуть и посмотреть, что это.",
      showcaseCount: "{count}/{max} закреплено",
      showcaseEmpty: "пока ничего не закреплено",
      genres: "Любимые жанры",
      genresCount: "{count} выбрано",
      genresHint: "Выберите, что вам нравится — это влияет на подборку на главной и «вам может понравиться» под каждым тайтлом. Настроить можно дважды: сейчас и ещё один раз позже — дальше список зафиксируется.",
      genresRemaining: "Осталось изменений: {count}",
      genresPicked: "Выбрано {count} из {max}",
      genresNonePicked: "Пока ничего не выбрано — найдите жанр ниже и нажмите на него.",
      genresSearch: "Найти жанр…",
      genresClear: "Очистить",
      genresRemove: "Убрать жанр «{genre}»",
      genresShowAll: "Показать ещё {count}",
      genresMax: "Можно выбрать не больше {max} жанров.",
      genresSaveError: "Не удалось сохранить жанры. Попробуйте ещё раз.",
      genresLocked: "Жанры настроены и больше не редактируются. Живой список любимых тайтлов, который тоже влияет на подборку, — без ограничений, в «Рекомендациях».",
      username: "Никнейм",
      usernameHint: "3–20 символов: a–z, 0–9, _. Задаётся один раз — используется в ссылке на профиль.",
      usernameClaimHint: "3–20 символов: a–z, 0–9, _. Можно задать только один раз.",
      usernameSet: "Никнейм сохранён",
      usernamePlaceholder: "например, shadow_fan",
      copyProfileLink: "Скопировать ссылку на профиль",
      titlePro: "Своя подпись",
      titleProHint: "Только для PRO: выберите короткую подпись и значок рядом с именем.",
      titlePlaceholder: "например, Повелитель аниме",
      titleClear: "Убрать",
      age: {
        title: "Подтверждение возраста",
        hint: "Открывает контент с пометкой R+ (18+, не хентай). Установить дату рождения можно только один раз.",
        saved: "Дата рождения сохранена",
        verifiedAdult: "Возраст подтверждён",
        verifiedMinor: "Дата сохранена",
        notSet: "Не подтверждён",
        neverHentai: "Хентай мы не показываем никому и ни при каких условиях, независимо от этой настройки.",
      },
      emailVerification: {
        title: "Подтвердите почту",
        unverified: "Не подтверждена",
        hint: "Почта {email} ещё не подтверждена. Это защищает аккаунт и позволяет восстановить пароль.",
        send: "Отправить код",
        sent: "Код отправлен — введите 6 цифр из письма или нажмите кнопку в нём.",
      },
      dangerZone: {
        deleteAccount: "Удалить аккаунт",
        dialogTitle: "Уходишь? Прямо сейчас?",
        dialogBody: "«{name}», весь список, каждый комментарий и все достижения исчезнут без следа — мы даже дослушать историю не успеем. Введите фразу ниже и свой пароль, если всё же решили попрощаться.",
        typePhrase: "Введите фразу для подтверждения",
        phraseMismatch: "Фраза не совпадает",
        password: "Пароль",
        passwordHintTelegram: "Для аккаунта через Google или Telegram пароль не задан.",
        confirm: "Удалить навсегда",
        cancel: "Отмена",
        wrongPassword: "Неверный пароль.",
        success: "Аккаунт удалён.",
      },
    },
  },
  achievements: {
    heading: "Достижения",
    viewAll: "Все достижения",
    earnedOfTotal: "Получено {earned}/{total}",
    locked: "Ещё не открыто",
    unavailable: "Пока недоступно",
    manualNote: "Отмечается вручную",
    rarity: {
      common: "Обычное",
      rare: "Редкое",
      epic: "Эпическое",
      legendary: "Легендарное",
    },
    progressLeft: "Осталось {n}",
    filterAll: "Все",
    filterEarned: "Получено",
    filterInProgress: "В процессе",
    filterLocked: "Ещё не открыты",
    earnedOn: "Получено {date}",
    noneInFilter: "Здесь пока пусто.",
    toast: "Новое достижение: {name}",
    category: {
      watch: "Просмотр",
      curator: "Подборки",
      community: "Сообщество",
      game: "Угадай аниме",
      special: "Особые",
    },
    items: {
      "thousand-episodes": { title: "Тысяча историй", desc: "Посмотреть 1000 серий" },
      "three-thousand-episodes": { title: "Большая аниме-история", desc: "Посмотреть 3000 серий" },
      "ten-series": { title: "Десять финалов", desc: "Досмотреть 10 тайтлов" },
      "twenty-five-series": { title: "Полка впечатлений", desc: "Досмотреть 25 тайтлов" },
      "fifty-series": { title: "Пятьдесят миров", desc: "Досмотреть 50 тайтлов" },
      "review-explorer": { title: "Свой взгляд", desc: "Оставить 25 оценок тайтлам" },
      "collection-architect": { title: "Архитектор подборок", desc: "Создать 10 подборок" },
      "collection-library": { title: "В поисках жемчужин", desc: "Открыть 50 разных подборок" },
      "curator-crowd": { title: "Большая аудитория", desc: "Собрать 5000 просмотров своих подборок" },
      "century-comments": { title: "Есть что обсудить", desc: "Написать 100 комментариев" },
      "guess-century": { title: "Сто попыток", desc: "Сыграть 100 раундов «Угадай аниме»" },
      "genre-master": { title: "Верность жанру", desc: "Посмотреть 200 серий одного жанра" },
      "five-hundred-episodes": {
        title: "500 серий",
        desc: "Посмотрите 500 серий суммарно.",
      },
      "curator-first": {
        title: "Куратор",
        desc: "Опубликуйте свою первую подборку.",
      },
      "curator-trio": {
        title: "Три подборки",
        desc: "Соберите три подборки аниме.",
      },
      "curator-views": {
        title: "Замечен",
        desc: "Наберите 100 просмотров своих подборок.",
      },
      "curator-famous": {
        title: "Знаменитость",
        desc: "Наберите 1000 просмотров своих подборок.",
      },
      "curator-liked": {
        title: "Народный выбор",
        desc: "Получите 25 оценок своих подборок.",
      },
      "curator-acclaimed": {
        title: "Признание",
        desc: "Средняя оценка подборок 4,5+ при 10 и более голосах.",
      },
      "curator-talk": {
        title: "Повод поговорить",
        desc: "Соберите 50 комментариев под своими подборками.",
      },
      "collection-reader": {
        title: "Читатель",
        desc: "Откройте 10 чужих подборок.",
      },
      "collection-judge": {
        title: "Жюри",
        desc: "Оцените 20 подборок других авторов.",
      },
      "discussant": {
        title: "Собеседник",
        desc: "Оставьте 20 комментариев под подборками.",
      },
      "guess-rookie": {
        title: "Игрок",
        desc: "Сыграйте 25 раундов «Угадай аниме».",
      },
      "guess-streak": {
        title: "Глаз-алмаз",
        desc: "Угадайте 10 кадров подряд.",
      },
      "guess-sharp": {
        title: "Ходячая энциклопедия",
        desc: "Угадайте 25 кадров подряд.",
      },
      "guess-top50": {
        title: "В таблице",
        desc: "Попадите в топ-50 «Угадай аниме».",
      },
      "guess-top10": {
        title: "Десятка лучших",
        desc: "Займите место в топ-10 «Угадай аниме».",
      },
      "secret-ghoul": {
        title: "Гуль",
        desc: "1000 − 7… Ты знаешь, что дальше.",
      },
      "secret-shinigami": {
        title: "Синигами",
        desc: "Яблоки любишь? Тетрадь теперь твоя.",
      },
      "secret-scout": {
        title: "Разведкорпус",
        desc: "Отдай своё сердце! За стену и обратно.",
      },
      "secret-hokage": {
        title: "Будущий Хокаге",
        desc: "Даттебайо! Путь ниндзя — не сдаваться.",
      },
      "secret-pirate": {
        title: "Король пиратов",
        desc: "Ван-Пис существует — и ты уже в пути.",
      },
      "secret-alchemist": {
        title: "Алхимик",
        desc: "Равноценный обмен: часы жизни на шедевр.",
      },
      "secret-scientist": {
        title: "Безумный учёный",
        desc: "El Psy Kongroo. Это выбор Врат Штейна.",
      },
      "secret-hero": {
        title: "Герой ради забавы",
        desc: "Ок. Сто отжиманий в день — и вот ты здесь.",
      },
      "secret-slayer": {
        title: "Истребитель демонов",
        desc: "Дыхание воды, первая форма. Закат не страшен.",
      },
      "secret-sorcerer": {
        title: "Маг",
        desc: "Расширение территории: твой список.",
      },
      "secret-devil": {
        title: "Охотник на дьяволов",
        desc: "Заводишь мотор — и вперёд.",
      },
      "secret-pilot": {
        title: "Пилот Евы",
        desc: "Нельзя убегать. Нельзя убегать. Нельзя убегать.",
      },
      "secret-hunter": {
        title: "Охотник",
        desc: "Нэн освоен. Лицензия хантера — твоя.",
      },
      "secret-spirit": {
        title: "Безликий",
        desc: "А-а… Ты не забыл своё имя?",
      },
      "guess-champion": {
        title: "Чемпион",
        desc: "Займите первое место в «Угадай аниме».",
      },
      "first-episode": {
        title: "Первая серия",
        desc: "Посмотрите свою самую первую серию.",
      },
      "first-series": {
        title: "Первый сериал",
        desc: "Досмотрите сериал от начала до конца.",
      },
      marathoner: {
        title: "Марафонец",
        desc: "Посмотрите 100 серий за одну неделю.",
      },
      "genre-expert": {
        title: "Знаток жанра",
        desc: "Посмотрите 50+ серий одного жанра.",
      },
      melomaniac: {
        title: "Меломан",
        desc: "Прослушайте 100+ опенингов или эндингов. Отмечается вручную.",
      },
      "first-donate": {
        title: "Первый донат",
        desc: "Впервые поддержите проект.",
      },
      patron: {
        title: "Меценат",
        desc: "Задонатьте суммарно от $100.",
      },
      critic: {
        title: "Критик",
        desc: "Оставьте 50 или больше комментариев.",
      },
      "anon-critic": {
        title: "Анонимный критик",
        desc: "Оставьте 50 анонимных комментариев.",
      },
      "hot-start": {
        title: "Жаркий старт",
        desc: "Посмотрите 10 серий за один день.",
      },
      bibliophile: {
        title: "Библиофил",
        desc: "Добавьте 100 тайтлов в планы.",
      },
      veteran: {
        title: "Ветеран",
        desc: "Наберите 1000 часов просмотра.",
      },
      "night-owl": {
        title: "Полуночник",
        desc: "Смотрите с полуночи до 5 утра.",
      },
      "first-review": {
        title: "Первая оценка",
        desc: "Поставьте оценку или оставьте заметку к тайтлу в своём списке.",
      },
      completionist: {
        title: "Перфекционист",
        desc: "Досмотрите все серии длинного сериала.",
      },
      "referral-guide": {
        title: "Проводник",
        desc: "Пригласите первого друга, который посмотрит хотя бы час.",
      },
      "referral-spark": {
        title: "Искра",
        desc: "Ваши друзья вместе посмотрели 20 часов аниме.",
      },
      "referral-ambassador": {
        title: "Посол",
        desc: "Пригласите 10 друзей.",
      },
      "referral-legend": {
        title: "Легенда сообщества",
        desc: "Пригласите 25 друзей.",
      },
      "referral-star": {
        title: "Звезда",
        desc: "Ваши друзья вместе посмотрели 500 часов аниме.",
      },
      "early-adopter": {
        title: "Ранний пользователь",
        desc: "Присоединитесь в первые месяцы проекта.",
      },
      supporter: {
        title: "Сторонник",
        desc: "Оформите PRO или оставьте донат.",
      },
      "week-streak": {
        title: "Неделя подряд",
        desc: "Смотрите что-нибудь семь дней подряд.",
      },
      "hundred-episodes": {
        title: "100 серий",
        desc: "Посмотрите 100 серий суммарно.",
      },
      "fifty-episodes": {
        title: "50 серий",
        desc: "Посмотрите 50 серий суммарно.",
      },
    },
  },
  comments: {
    heading: "Комментарии",
    count: "комментариев: {count}",
    viewProfile: "Профиль пользователя",
    placeholder: "Написать комментарий…",
    submit: "Отправить",
    spoiler: "Спойлер",
    spoilerReveal: "Спойлер — показать текст",
    spoilerHide: "Скрыть спойлер",
    mode: {
      public: "Публичный",
      anon: "Анонимный",
      donators: "Только для донатеров",
      publicHint: "Опубликуется под вашим именем.",
      anonHint: "Ваше имя останется скрытым.",
      donatorsHint: "Увидят только донатеры.",
    },
    anonDisplay: "Аниме-ниндзя #{n}",
    sort: {
      newest: "Новые",
      oldest: "Старые",
      best: "Лучшие",
    },
    filter: {
      donators: "Только донатеры",
      anon: "Только анонимы",
    },
    actions: {
      reply: "Ответить",
      edit: "Изменить",
      delete: "Удалить",
      quote: "Цитировать",
      report: "Пожаловаться",
    },
    edited: "изменено",
    deleted: "Комментарий удалён",
    confirmDeleteTitle: "Удалить комментарий?",
    confirmDeleteBody: "Это действие нельзя отменить.",
    signInToComment: "Войдите, чтобы комментировать",
    empty: "Пока нет комментариев. Будьте первым.",
    likeAria: "Лайк комментарию",
    dislikeAria: "Дизлайк комментарию",
  },
  plans: {
    title: "PRO-подписка",
    subtitle: "Смотреть можно бесплатно — весь каталог, плеер до 720p. PRO — для тех, кто хочет больше.",
    compare: "Что входит",
    disclaimer: "Оплата пока не подключена — кнопки ведут на страницу поддержки проекта.",
    best: "Выгоднее всего",
    monthly: "Помесячно, без скидки",
    perMonthIs: "{price} в месяц",
    save: "экономия {n}%",
    cta: "Оформить на {period}",
    months: { m1: "1 месяц", m3: "3 месяца", m12: "12 месяцев" },
    perks: {
      p1: "Качество до 1080p в своём плеере",
      p2: "Фильтры картинки: яркость, контраст, цвет",
      p3: "Свои комнаты до 10 человек — с чатом, стикерами и гифками",
      p4: "Вся история просмотра и подборки без лимита",
      p5: "Знак Anivora у ника, свой значок и подпись в профиле",
    },
  },
  home: {
    genreCount: "{count} тайтлов",
    genreOpen: "Смотреть жанр",
    genrePreview: "Например",
    allGenres: "Все жанры",
    allGenresNote: "Каталог с фильтрами",
    seasonsTitle: "По сезонам",
    actions: {
      browse: "Каталог",
      browseNote: "Фильтры, сортировки, поиск",
      browseHint: "Подобрать аниме по жанрам, году и оценке",
      frame: "Поиск по кадру",
      frameNote: "Скриншот — и мы найдём тайтл",
      frameHint: "Загрузите кадр из серии, чтобы узнать, что это за аниме",
      recs: "Рекомендации",
      recsShort: "Для вас",
      recsNote: "Подборка под ваш вкус",
      recsHint: "Составляется по вашему списку и оценкам",
      random: "Случайное аниме",
      randomNote: "Когда не знаешь, что включить",
      randomHint: "Откроет случайный тайтл из каталога",
    },
    trendingNow: "Смотрят прямо сейчас",
    trendingNowSub: "Недавние просмотры и популярное из каталога",
    season: "Сезон {year}",
    seasonSub: "Новые серии этого сезона",
    trendingMonth: "Популярное",
    trendingMonthSub: "Выбор зрителей за месяц и популярные тайтлы",
    topRated: "Рейтинг сообщества",
    topRatedSub: "Высшие оценки на длинной дистанции",
    upcoming: "Скоро на экранах",
    upcomingSub: "Анонсированные премьеры",
    recommended: "Для вас",
    recommendedSubLiked: "Подобрано по тайтлам, которые вам понравились",
    recommendedSub: "Подобрано по вашим любимым жанрам",
    recommendedSubHistory: "Подобрано по жанрам, которые вы смотрите",
    recommendedSubTrending: "Сейчас в тренде — настройте под себя в",
    recommendedSubAnon: "Войдите — и здесь появится персональная подборка",
    continueRail: "Продолжить просмотр",
    continueRailSub: "Вернитесь к тому, на чём остановились",
    genresTitle: "Загляните в жанр",
    genresPersonal: "Подобрано по вашим вкусам и списку",
    genresDefault: "Самые популярные — войдите, и мы подберём под вас",
    heroRank: "#{rank} в тренде",
    heroWatch: "Смотреть",
    heroPause: "Остановить слайдер",
    heroPlay: "Запустить слайдер",
    game: {
      lockedTitle: "Играть могут только участники",
      lockedBody: "Войдите или зарегистрируйтесь — серия будет засчитываться, а лучший результат попадёт в таблицу лидеров.",
      boardCount: "топ-{n}",
      streakNow: "Угадано подряд в этой серии",
      bestNow: "Ваш рекорд",
      over: "Серия окончена: {n}",
      again: "Сыграть ещё",
      keys: "Клавиши 1–4 — ответ, Enter — новая серия",
      board: "Таблица лидеров",
      boardEmpty: "Пока никто не играл — станьте первым в таблице",
      myPlace: "Ваше место: {n}",
      signInForBoard: "Войдите, чтобы попасть в таблицу лидеров",
    },
    corner: {
      title: "Аниме-уголок",
      subtitle: "Не очередная полка: аниме дня, мини-игра и факты",
      pick: "Аниме дня",
      guess: "Угадай по кадру",
      guessHint: "Какое это аниме?",
      guessRight: "В точку!",
      guessWrong: "Мимо — верный ответ подсвечен",
      streak: "Серия угаданных подряд. Рекорд: {best}",
      open: "Открыть",
      again: "Ещё",
      facts: "А вы знали?",
    },
    facts: {
      more: "Ещё факты",
      sazae: {
        title: "«Садзаэ-сан» идёт с 1969 года",
        body: "Это самый долгий анимационный сериал в истории — он занесён в Книгу рекордов Гиннесса и до сих пор выходит каждое воскресенье.",
      },
      astro: {
        title: "Всё началось с «Астробоя»",
        body: "«Тэцуван Атом» Осаму Тэдзуки вышел 1 января 1963 года и задал формат японского ТВ-аниме: еженедельные получасовые серии.",
      },
      spirited: {
        title: "Два «Оскара» у Миядзаки",
        body: "«Унесённые призраками» в 2003 году первыми из аниме получили «Оскар» за лучший анимационный фильм. В 2024-м его взял и «Мальчик и птица».",
      },
      onepiece: {
        title: "One Piece — рекорд Гиннесса",
        body: "Манга Эйитиро Оды — самый издаваемый комикс одного автора в мире. Аниме выходит с 1999 года и перевалило за тысячу серий.",
      },
      word: {
        title: "В Японии «аниме» — это любой мультфильм",
        body: "Слово アニメ — просто сокращение от английского animation. Для японцев «Король Лев» — тоже аниме.",
      },
      ghibli: {
        title: "Откуда имя Ghibli",
        body: "Студию основали в 1985 году Миядзаки, Такахата и Судзуки. Название — от итальянского самолёта Caproni Ca.309 Ghibli, а тот назван в честь горячего ветра Сахары.",
      },
      pokemon: {
        title: "Серия, изменившая ТВ",
        body: "Мигающие кадры в эпизоде «Покемона» о Поригоне (1997) отправили в больницы Японии сотни детей. После этого японское ТВ ввело правила для вспышек на экране.",
      },
      akira: {
        title: "«Акира» рисовали под голос",
        body: "Диалоги для фильма 1988 года записали до анимации, и движения губ рисовали под них — для аниме тех лет редкость. В фильме больше 160 000 рисунков.",
      },
    },
    views: "{views} просмотров",
    continueWatching: "Продолжить · {done}/{total}",
    ongoing: "Онгоинг",
    firstVisit: {
      title: "Впервые на Anivora?",
      text: "Один каталог, список просмотра и прогресс по эпизодам.",
      link: "Как это устроено",
    },
  },
  seo: {
    share: "Поделиться",
    shareVk: "ВКонтакте",
    shareTelegram: "Telegram",
    shareTwitter: "Twitter",
    copyLink: "Скопировать ссылку",
    linkCopied: "Ссылка скопирована",
    titleTemplate: "{title} смотреть онлайн все серии бесплатно | Anivora",
    descriptionTemplate:
      "{title} — {type}, {year}. Рейтинг {score}. Жанры: {genres}. Смотрите онлайн.",
    homeTitle: "Anivora — смотреть аниме онлайн бесплатно в хорошем качестве",
    homeDescription:
      "Каталог аниме на русском: обзоры, рейтинги, список просмотра и прогресс по эпизодам. Смотрите онлайн.",
  },
};
